import React, { useEffect, useState } from "react";
import "./Objectives.css";
import { Col, Container, Row } from "react-bootstrap";
const Objectives = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const content = [
    {
      title: "Design Philosophy",
      body: "Exceptional architecture blends purpose, aesthetics, and experience. Our designs prioritize function, celebrate detail, and capture each space’s unique essence.",
    },
    {
      title: "Specifics",
      body: "We provide complete architecture services—residential, commercial, and interior—crafting spaces that are both harmonious and visually striking.",
    },
    {
      title: "Detailing",
      body: "We believe every detail matters. Our meticulous approach ensures each design exceeds expectations",
    },
    {
      title: "Creativity",
      body: "Our expertise blends innovation, functionality, and aesthetics—transforming spaces from concept to creation with passion, precision, and architectural finesse.",
    },
    {
      title: "Client Satisfaction",
      body: "We design functional, visually appealing spaces that reflect our clients' vision, with satisfaction at the core of every project.",
    },
  ];
  const mobContent1 = [content[0], content[1], content[2]];
  const mobContent2 = [content[3], content[4]];
  console.log(mobContent1)
  useEffect(() => {
    const handleResize = () => {
      setWidth(window.innerWidth);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <div className="objectives">
      <div className="title">
        <h1>OBJECTIVES</h1>
      </div>
      <Container>
        <Row>
          {width >= 1200 && (
            <div className="objectivesBody">
              {content.map((item, index) => (
                // <Col lg={3}>
                <div className="flipCard" key={item.title}>
                  <div className="flipCardInner">
                    <div className="flipCardFront">{item.title}</div>
                    <div className="flipCardBack">{item.body}</div>
                  </div>
                </div>
                // </Col>
              ))}
            </div>
          )}
          {width < 1200 && (
            <div className="mobjectivesBody">
              <div className="mob1container">
                {mobContent1.map((item, index) => (
                  // <Col lg={3}>
                  <div className="flipCard" key={item.title}>
                    <div className="flipCardInner">
                      <div className="flipCardFront">{item.title}</div>
                      <div className="flipCardBack">{item.body}</div>
                    </div>
                  </div>
                  // </Col>
                ))}
              </div>
              <div className="mob2container">
                {mobContent2.map((item, index) => (
                  // <Col lg={3}>
                  <div className="flipCard" key={item.title}>
                    <div className="flipCardInner">
                      <div className="flipCardFront">{item.title}</div>
                      <div className="flipCardBack">{item.body}</div>
                    </div>
                  </div>
                  // </Col>
                ))}
              </div>
            </div>
          )}
        </Row>
      </Container>
    </div>
  );
};

export default Objectives;
